"use strict";
/**
 * @module Services.Security
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var conversation_id_serialiser_1 = require("./../../conversation/conversation-id-serialiser");
var serialiser_1 = require("./../../serialisers/serialiser");
var authenticator_registration_parameters_serialiser_1 = require("./authenticator-registration-parameters-serialiser");
var authenticator_registration_request_1 = require("./authenticator-registration-request");
/**
 * Serialiser for {@link AuthenticatorRegistrationRequest}
 */
var AuthenticatorRegistrationRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(AuthenticatorRegistrationRequestSerialiserClass, _super);
    function AuthenticatorRegistrationRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link AuthenticatorRegistrationRequest} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link AuthenticatorRegistrationRequest} that was read
     */
    AuthenticatorRegistrationRequestSerialiserClass.prototype.read = function (bis) {
        var params = authenticator_registration_parameters_serialiser_1.AuthenticatorRegistrationParametersSerialiser.read(bis);
        var cid = conversation_id_serialiser_1.CIDSerialiser.read(bis);
        return new authenticator_registration_request_1.AuthenticatorRegistrationRequest(params, cid);
    };
    /**
     * Write a {@link AuthenticatorRegistrationRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link AuthenticatorRegistrationRequest} to be written
     */
    AuthenticatorRegistrationRequestSerialiserClass.prototype.write = function (bos, value) {
        authenticator_registration_parameters_serialiser_1.AuthenticatorRegistrationParametersSerialiser.write(bos, value.params);
        conversation_id_serialiser_1.CIDSerialiser.write(bos, value.cid);
    };
    return AuthenticatorRegistrationRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.AuthenticatorRegistrationRequestSerialiserClass = AuthenticatorRegistrationRequestSerialiserClass;
/**
 * The {@link AuthenticatorRegistrationRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.AuthenticatorRegistrationRequestSerialiser = new AuthenticatorRegistrationRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/security/authenticator-registration-request-serialiser.js
// module id = 1614
// module chunks = 1